import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { TravelerTypes, TravelerInfoType } from '@pax/entities/traveler-info';
import { PaxFormService } from '@pax/services/pax-form.service';
import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { PaxOrdinalLabelPipe } from '@pax/pipes/pax-ordinal-label.pipe';
import {
  DataActionCardInfoType, DataActionFailedType
} from '@design-system/components/templates/data-action-card/entities/data-action-card.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-new-pax',
  templateUrl: './new-pax.component.html',
  styleUrls: ['./new-pax.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NewPaxComponent {

  @Input() type: TravelerTypes;
  @Input() ordinalKey: string;
  @Input() moreThanOneUser: boolean;
  @Input() isHome: boolean;
  @Input() isError: boolean = false;
  @Input() label: string;
  @Input() icon: Icon;
  @Input() travelerInfoType: TravelerInfoType = TravelerInfoType.PASSENGER;
  @Input() listUILength: number;
  @Input() travelerBookingProvider: TravelBookingType;
  @Input() travelerAge: number | null = null;

  @Output() addPax: EventEmitter<void> = new EventEmitter();
  @Output() openList: EventEmitter<void> = new EventEmitter();
  @Output() swipeClick: EventEmitter<void> = new EventEmitter();

  public readonly dataActionCardInfoType = DataActionCardInfoType;
  public readonly dataActionFailedType = DataActionFailedType;

  public readonly icons = Icon;

  constructor(
    private paxFormService: PaxFormService,
    private paxOrdinalLabelPipe: PaxOrdinalLabelPipe,
  ) { }

  get typeIcon(): string {
    return this.type === TravelerTypes.ADULTS ? Icon.PersonOutline : Icon.Children;
  }

  get selectionIcon(): Icon {
    return this.moreThanOneUser ? Icon.ChevronRight : Icon.Add;
  }

  get newPaxlabel(): string {
    return this.paxOrdinalLabelPipe.transform(
      !!this.listUILength, this.travelerBookingProvider, this.type, this.ordinalKey, this.travelerAge
    );
  }

  public emit(): void {
    if (this.moreThanOneUser) {
      this.openList.emit();
    } else this.addPax.emit();
  }

}
